import * as React from 'react'

import { Box, type Colors, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  status: PaymentStatus
}

export type PaymentStatus =
  | 'not_paid'
  | 'paid'
  | 'partially_paid'
  | 'overpaid'
  | 'processing'
  | 'pending'

const statusToTagColor: Record<PaymentStatus, Colors> = {
  not_paid: 'radicalRed200',
  paid: 'lime200',
  partially_paid: 'champagne400',
  overpaid: 'radicalRed200',
  processing: 'champagne400',
  pending: 'champagne400',
}

const ShowStatus = ({ status }: Props) => {
  const background = statusToTagColor[status]
  const statusLabel: Record<PaymentStatus, string> = {
    not_paid: i18n.t('payroll_bundle.statuses.not_paid'),
    paid: i18n.t('payroll_bundle.statuses.paid'),
    partially_paid: i18n.t('payroll_bundle.statuses.partially_paid'),
    overpaid: i18n.t('payroll_bundle.statuses.overpaid'),
    processing: i18n.t('payroll_bundle.statuses.processing'),
    pending: i18n.t('payroll_bundle.statuses.pending'),
  }

  return (
    <Box
      background={background}
      paddingX="s8"
      paddingY="s2"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Text.Normal size="200">{statusLabel[status]}</Text.Normal>
    </Box>
  )
}

export default ShowStatus
